import { Component } from '@angular/core';

@Component({
    selector: 'tun-thumb-up-icon-v5',
    templateUrl: './thumb-up-icon-v5.component.html',
    styleUrls: ['./thumb-up-icon-v5.component.scss'],
    standalone: false
})
export class ThumbUpIconV5Component {

}
